/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default memo(function Index({ employeesPerCity }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);

  useEffect(() => {
    let cityData = {};
    if (employeesPerCity?.length) {
      cityData = {
        datasets: [
          {
            data: employeesPerCity?.map((item) => item?.count) || [],
            backgroundColor:
              employeesPerCity?.map((item) => item?.backgroundColor) || [],
            hoverOffset: 4
          }
        ],
        labels: employeesPerCity.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };
    }
    setGraphData(cityData);
  }, [employeesPerCity]);

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };

  const translatedLegends = employeesPerCity
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor
    }))
    .sort(({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
    );
  return (
    <Graph
      graphData={graphData}
      legends={translatedLegends}
      title={t("Ville de résidence")}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef}
    />
  );
});
